import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

const formatText = ({ data, i18n }) => {
  if (!data || data.length === 0) {
    return i18n.getString(_TL_('All genres'));
  }

  if (data.length === 1) {
    return i18n.getString(_TL_('1 genre'));
  }

  return i18n.getString(_TL_('{{count}} genres'), { count: data.length });
};

export const Genre = ({ genreTargets }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Genre') }}>
      <Text>{formatText({ data: genreTargets, i18n })}</Text>
    </PropertyRow>
  );
};

Genre.propTypes = {
  genreTargets: PropTypes.arrayOf(PropTypes.shape({})),
};

Genre.defaultProps = {
  genreTargets: [],
};
